import React from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import SideBar from './sideBar'

import {RedocStandalone} from 'redoc';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            {/*<Link color="inherit" href="https://material-ui.com/">*/}
            {/*    Your Website*/}
            {/*</Link>{' '}*/}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

export default function Dashboard() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return (
        <Router>
            <div className={classes.root}>
                <CssBaseline/>
                <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                    <Toolbar className={classes.toolbar}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                            SafeSport
                        </Typography>
                    </Toolbar>
                </AppBar>
                <SideBar classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}/>
                {/*<Drawer*/}
                {/*    variant="permanent"*/}
                {/*    classes={{*/}
                {/*        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),*/}
                {/*    }}*/}
                {/*    open={open}*/}
                {/*>*/}
                {/*    <div className={classes.toolbarIcon}>*/}
                {/*        <IconButton onClick={handleDrawerClose}>*/}
                {/*            <ChevronLeftIcon/>*/}
                {/*        </IconButton>*/}
                {/*    </div>*/}
                {/*    <Divider/>*/}
                {/*    <List>{mainListItems}</List>*/}
                {/*</Drawer>*/}
                <main className={classes.content}>
                    <div className={classes.appBarSpacer}/>
                    <Container maxWidth="lg" className={classes.container}>
                        <Switch>
                            <Route exact path="/">
                                <RedocStandalone specUrl="spec/lmsinfo.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/lmsapi">
                                <RedocStandalone specUrl="spec/openapi.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/authentication">
                                <RedocStandalone specUrl="spec/openapi-infuse.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/profile">
                                <RedocStandalone specUrl="spec/openapi-profile.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/catalog">
                                <RedocStandalone specUrl="spec/openapi-catalog.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/courses">
                                <RedocStandalone specUrl="spec/openapi-courses.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/transcript">
                                <RedocStandalone specUrl="spec/openapi-transcript.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/lesson">
                                <RedocStandalone specUrl="spec/openapi-lesson.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                            <Route path="/adjlog">
                                <RedocStandalone specUrl="spec/openapi-adjudication.yaml"
                                                 options={{
                                                     nativeScrollbars: true,
                                                     theme: {colors: {primary: {main: '#dd5522'}}},
                                                 }}/>
                            </Route>
                        </Switch>
                        <Box pt={4}>
                            <Copyright/>
                        </Box>
                    </Container>
                </main>
            </div>
        </Router>
    );
}
